import { HTMLAttributes } from 'react';
import { E1Link } from '../../../E1Link';
import styles from './styles.module.scss';

export type FieldNotificationWithLinkProps = HTMLAttributes<HTMLDivElement> & {
  message: string;
  url: string;
  urlText: string;
};

export type FieldNotification = string | FieldNotificationWithLinkProps;

export const isFieldNotificationWithLink = (
  notification: FieldNotification
): notification is FieldNotificationWithLinkProps =>
  (notification as FieldNotificationWithLinkProps).message !== undefined;

export const FieldNotificationWithLink = ({ message, url, urlText }: FieldNotificationWithLinkProps) => (
  <div className={styles.fieldNotificationWithLink}>
    <span>{message}</span>
    <E1Link link={url}>{urlText}</E1Link>
  </div>
);
